export default __webpack_public_path__ + "static/media/icon__3.f5a43ddd.svg";